export enum MissionType {
  EVACUATE = 'evacuate',
  DEDICATED = 'dedicated',
  OTHER = 'other',
}
